export default "__VITE_ASSET__8367ec85__"